import { useQueryClient } from 'react-query';
import { usePrescriptionsIFrame } from 'shared/features/erx';
export var useMedicationsPrescribeIFrame = function (memberId, memberUserId, appointmentId, endDate) {
    var queryClient = useQueryClient();
    return usePrescriptionsIFrame(function () {
        // TODO clear relevant queries on page (ie allergies, active medications)
        queryClient.invalidateQueries('erx-notifications');
        queryClient.invalidateQueries(['member-allergies', memberUserId]);
        queryClient.invalidateQueries(['erx-prescriptions-url', memberUserId]);
        queryClient.invalidateQueries(['member-medications', memberUserId + endDate]);
    }, memberId, appointmentId);
};
